import React from 'react';
import { useIntl } from 'react-intl';
import { Lx } from '../../../../i18n/consts';
import ProfileInfoCard from '../profile-info-card';
import styles from '../../profile.module.scss';
import ProfileTabPage from '../profile-tab-page';
import { useProfileData } from '../../hooks/useProfileData';

const ProfileProjectsPage = () => {
    const intl = useIntl();
    const { profile, loading } = useProfileData();
    const emptyValueLabel = intl.formatMessage({ id: Lx.General.NOT_AVAILABLE });

    return (
        <ProfileTabPage activeTab={'projects'} loading={loading}>
            <div className={styles.profileCardLayout}>
                <div className={styles.profileCards}>
                    <ProfileInfoCard
                        key='projects'
                        labelId={Lx.General.PROJECTS}
                        value={profile.projects}
                        emptyValue={emptyValueLabel}
                    />
                </div>
            </div>
        </ProfileTabPage>
    );
}

export default React.memo(ProfileProjectsPage);
